<template>
    <MainContentSearchable 
        title='Listado de preguntas frecuentes' 
        v-model="filters" 
        :meta="faqs.meta"
        @updated="debouncedGetFaqs"
    >
        <template v-slot:header>
            <h3 class="card-title mb-3">
                Listado de preguntas
            </h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <div v-if="!loading" class="table-responsive has-options">
                    <ExpandableList 
                        hover 
                        :items="faqs.data" 
                        :link="link" 
                        id="faq-table"
                    >
                        <template #cell(description)="{ item }">
                            <div v-html="item.description" class="descripcion">
                            </div>
                        </template>
                        <template #cell(opciones)="{ item }">
                            <router-link 
                                :to="{ name: 'back.faqs.show', 
                                       params: { faq_id: item.id } }"
                                class="btn btn-primary"
                                target="blank"
                            >
                                Detalles
                            </router-link>
                        </template>
                    </ExpandableList>
                    <hr v-if="faqs.data.length > 0"/>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import ExpandableList from '@/components/frontend/components/ExpandableList.vue';

    export default {
        components: {
            MainContentSearchable,
            ContentOrLoading,
            ExpandableList
        },
        data() {
            return {
                faqs: { data: [], meta: { current_page: 1 } },
                loading: true,
                filters:
                    {
                        per_page: 10,
                        page: 1,
                        search: "",
                    },
                fields:
                    [
                        { key: 'title', label: 'Título' },
                        { key: 'description', label: 'Descripción' },
                        { key: 'opciones', label: 'opciones', class: 'text-center' }
                    ],
                link: 'back.faqs.show'
            }
        },
        created() {
            this.getFaqs();
            this.debouncedGetFaqs = _.debounce(this.getFaqs, 500)
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
        },
        methods: {
            getFaqs: function() {
                this.loading = true;
                const params = {
                    filters: {
                        tipo: this.manager.tipo === 1 ? 'deportivo' : 'teatro',
                    ...this.filters
                    },
                };
                this.$store
                    .dispatch(this.config.getVuexAlias('back.faqs.index'), params)
                    .then(res => {
                        this.faqs = res.data;
                    })
                    .finally(() => this.loading = false);
            },
            setPage(page) {
                this.filters.page = page;
                this.getFaqs();
            },
        },
    }
</script>